function formatDate(value) {
  if (!value) return "-";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "-";

  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(parsed);
}

function normalizeStatus(rawValue) {
  const value = String(rawValue || "").trim().toLowerCase();
  if (!value) {
    return {
      label: "Unknown",
      className: "bg-slate-100 text-slate-700 ring-slate-200",
    };
  }

  if (value === "active" || value === "approved") {
    return {
      label: "Active",
      className: "bg-emerald-50 text-emerald-700 ring-emerald-200",
    };
  }

  if (value === "hold" || value === "on hold") {
    return {
      label: "Hold",
      className: "bg-amber-50 text-amber-800 ring-amber-200",
    };
  }

  return {
    label: rawValue,
    className: "bg-slate-100 text-slate-700 ring-slate-200",
  };
}

export default function PlatformActorListCard({
  title,
  subtitle,
  actors,
  loading,
  error,
  emptyMessage,
  showPartnerColumn = false,
}) {
  return (
    <div className="rounded-[10px] border border-slate-200 bg-white shadow-sm">
      <div className="border-b border-slate-100 px-5 py-4">
        <div className="flex items-center justify-between gap-3">
          <div>
            <h2 className="text-base font-semibold text-slate-900">{title}</h2>
            {subtitle ? (
              <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
            ) : null}
          </div>
          <div className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700 ring-1 ring-inset ring-emerald-200">
            {loading ? "Loading..." : `${actors.length} total`}
          </div>
        </div>
      </div>

      <div className="px-5 py-4">
        {error ? (
          <div className="rounded-[10px] border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
            {error}
          </div>
        ) : null}

        {!error && loading ? (
          <div className="space-y-3">
            <div className="h-10 animate-pulse rounded-[10px] bg-slate-100" />
            <div className="h-10 animate-pulse rounded-[10px] bg-slate-100" />
            <div className="h-10 animate-pulse rounded-[10px] bg-slate-100" />
          </div>
        ) : null}

        {!error && !loading && actors.length === 0 ? (
          <div className="rounded-[10px] border border-dashed border-slate-200 bg-slate-50 px-4 py-8 text-center text-sm text-slate-500">
            {emptyMessage}
          </div>
        ) : null}

        {!error && !loading && actors.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="border-b border-slate-100 text-left text-xs font-semibold uppercase tracking-[0.16em] text-slate-400">
                  <th className="px-3 py-3">Name</th>
                  <th className="px-3 py-3">Email</th>
                  <th className="px-3 py-3">Status</th>
                  {showPartnerColumn ? (
                    <th className="px-3 py-3">Linked Partner</th>
                  ) : null}
                  <th className="px-3 py-3">Created</th>
                </tr>
              </thead>
              <tbody>
                {actors.map(actor => {
                  const status = normalizeStatus(actor?.status);
                  const partnerLabel = actor?.partnerName || actor?.partnerEmail || "-";

                  return (
                    <tr
                      key={String(actor?.userId || actor?.email || actor?.fullName)}
                      className="border-b border-slate-100 last:border-b-0"
                    >
                      <td className="px-3 py-3 font-medium text-slate-900">
                        {actor?.fullName || "-"}
                      </td>
                      <td className="px-3 py-3 text-slate-600">{actor?.email || "-"}</td>
                      <td className="px-3 py-3">
                        <span
                          className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset ${status.className}`}
                        >
                          {status.label}
                        </span>
                      </td>
                      {showPartnerColumn ? (
                        <td className="px-3 py-3 text-slate-600">{partnerLabel}</td>
                      ) : null}
                      <td className="px-3 py-3 text-slate-600">
                        {formatDate(actor?.createdAt)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : null}
      </div>
    </div>
  );
}
